import React, { useEffect } from "react";
import "./Invoice80mm.css";
import { dynamicImage } from "../../../../Service";
import { useParams } from "react-router-dom";
import api from "../../../../utils/api";

const LockerInvoice = () => {
    const params = useParams();
    const lockerCalculationId = params.id || "0";
     const [items, setItems] = React.useState<any>('');
  // const items = [
  //   { name: "Small Locker", quantity: 1, LockerNumber: '1,2', price: 0 },
  //   { name: "Big Locker", quantity: 2, LockerNumber: '3,4', price: 0 },
  // ];

   const lockerDetails = async () => {
      try {
        const res = await api.get(`/api/LockerCalculation/LockerBiling?lockerCalculationId=${lockerCalculationId}`);
        if (res.status === 200) {
          // Process the response data
          const data = res.data;
          setItems(data);
        }
      } catch (error) {
        // console.error("Error fetching food order:", error);
      }
    };

   useEffect(() => {
    lockerDetails();
      if (items !== '') {
          window.print();
      } else {
          setTimeout(window.print, 1000);
      }
    }, []);
    const handlePrint = () => {
      window.print();
    };

  return (
    <>
    {items && 
    <div className='page-body'>
      <div className="invoice-container">
        <button className="print-button" onClick={handlePrint}>🖨️ Print</button>
        <div className="invoice">
          <div className="logo">
            <img src={dynamicImage("logo/logo.png")} alt="Logo" />
            <h2>SHIVALYA WATER PARK</h2>
          </div>

          <div className="details">
            <p><strong>Ticket No.:</strong> {items.ticketRFIdRef}</p>
            <p><strong>RFID Card No.:</strong> {items.selectedCard}</p>
            <p><strong>Customer Name:</strong> {items.customerName}</p>
            <p><strong>Mobile Number:</strong> {items.customerMobileNumber}</p>
          </div>

          <table className="item-table">
            <thead>
              <tr>
                <th>Big Locker</th>
                <th>Small Locker</th>
                <th>Quantity</th>
                <th>Locker No.</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{items.bigLocker}</td>
                <td>{items.smallLocker}</td>
                <td>{items.totalQuantity}</td>
                <td>{items.lockerNumber}</td>
              </tr>
            </tbody>
          </table>

          <div className="totals">
            <p><strong>Sub Total :</strong> Rs {items.subTotalAmount}</p>
            <p><strong>GST :</strong> Rs {items.gst}</p>
            <p><strong>Refund Amount :</strong> Rs {items.refundableAmount}</p>
            <p><strong>Total Amount :</strong> Rs {items.grandTotalAmount}</p>
          </div>
        </div>
      </div>
    </div>
  }
    </>
  );
};

export default LockerInvoice;
